import styled from 'styled-components';

const StyledHero3dCommerce = styled.div`
  position: relative;
  padding: 94px 64px 0;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
  .title--wrap{
    position: relative;
    text-align: left;
    color:#000;
    width: 50%;
    z-index: 2;
    padding-top: 80px;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 1023px){
      padding-top: 40px;
    }

    .rounded--cta {
      position: relative;
      top: 120px;
      display: inline-flex;
      width: auto;
      align-self: flex-start;
      
      @media screen and (max-width: 1023px){
        top: 0;
        align-self: center;
        width: 100%;
        margin-bottom: 80px;
        p {
          width: 100%;
        }
      }
    }
  }
  h4{
    width: 100%;
    padding-bottom: 40px;
  }
  .subtitle-slider {
    position: relative;
    width: 100%;
    p {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transform: none;
      text-align: left;
      width: auto;
    }
    @media screen and (max-width: 1023px){
      height: 120px;
      p {
        text-align: center;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
      }
    }
  }


  @media screen and (max-width: 1439px){
    padding: 94px 40px 0;
  }
  @media screen and (max-width: 1023px){
    flex-flow: column-reverse nowrap;
    justify-content: center;
    align-items: center;
    .title--wrap, img{
      width: 100%;
    }
    .title--wrap{
      margin-top: 0;
      text-align: center;
    }
    p{
      width: 66.66%;
    }
  }
  @media screen and (max-width: 767px){
    padding: 81px 24px 0;
    
    .title--wrap{
      max-width: 100%;
    }
    img, p{
      width: calc(100% - 48px);
    }
  }
`;

export {
  StyledHero3dCommerce,
};

